import { showNotification } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { axiosGet } from "../Helpers/AxiosHelper";
import { Token } from "../Helpers/UserDetails";
import UserContext from "./userContext";
const UserProvider = (props) => {
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [show, setShow] = useState(false);

  const [swapUser, setSwapUser] = useState(localStorage.getItem("swapUser") || JSON.parse(localStorage.getItem("user"))?.userType);

  const [isAdmin, setIsAdmin] = useState(JSON.parse(localStorage.getItem("user"))?.userType === "Admin");
  const [isSuperAdmin, setIsSuperAdmin] = useState(
    JSON.parse(localStorage.getItem("user"))?.userType === "Admin" && JSON.parse(localStorage.getItem("user"))?.isSuperAdmin,
  );
  const [isGeneralManager, setIsGeneralManager] = useState(JSON.parse(localStorage.getItem("user"))?.userType === "General Manager");
  const [isSalesManager, setIsSalesManager] = useState(JSON.parse(localStorage.getItem("user"))?.userType === "Sales Manager");
  const [isLotGuy, setIsLotGuy] = useState(JSON.parse(localStorage.getItem("user"))?.userType === "Lot Guy" || swapUser === "Lot Guy");
  const [isServiceManager, setIsServiceManager] = useState(JSON.parse(localStorage.getItem("user"))?.userType === "Service Manager");
  const [isSalesAgent, setIsSalesAgent] = useState(
    JSON.parse(localStorage.getItem("user"))?.userType === "Sales Person" || swapUser === "Sales Person",
  );

  const [isVendor, setIsVendor] = useState(
    JSON.parse(localStorage.getItem("user"))?.userType === "Service Vendor" || swapUser === "Service Vendor",
  );

  const [isFinanceManager, setIsFinanceManager] = useState(
    JSON.parse(localStorage.getItem("user"))?.userType === "Finance Manager" || swapUser === "Finance Manager",
  );
  const [isDispatcher, setIsDispatcher] = useState(
    JSON.parse(localStorage.getItem("user"))?.userType === "Auction Manager" || swapUser === "Auction Manager",
  );
  const token = Token();

  const getMyData = () => {
    axiosGet({ url: "/me" })
      .then((response) => {
        let data = response.data.data;

        setUser(data);

        setUserType(`${response?.data?.data?.userType?.toLowerCase()?.replaceAll(" ", "")}`);
      })

      .catch((err) => {
        console.log(err.message);
        showNotification({
          title: "Error",
          message: "Something went wrong, please try again later",
          color: "red",
        });
      });
  };
  useEffect(() => {
    if (token) getMyData();
  }, []);

  useEffect(() => {
    if (userType === "Service Manager") {
      setIsServiceManager(true);
      if (swapUser === "Lot Guy") {
        setIsLotGuy(true);
        setIsVendor(false);
      } else if (swapUser === "Service Vendor") {
        setIsVendor(true);
        setIsLotGuy(false);
      } else {
        setIsVendor(false);
        setIsLotGuy(false);
      }
    }
  }, [swapUser, userType]);

  const values = {
    user,
    setUser,
    userType,
    setUserType,
    token,
    setIsGeneralManager,

    setSwapUser,
    swapUser,

    setShow,
    show,

    setIsAdmin,
    setIsSalesManager,
    setIsDispatcher,
    setIsLotGuy,
    setIsVendor,
    setIsSalesAgent,
    setIsFinanceManager,
    setIsServiceManager,

    isAdmin,
    isFinanceManager,
    isGeneralManager,
    isDispatcher,
    isSalesAgent,
    isSalesManager,
    isLotGuy,
    isVendor,
    isSuperAdmin,
    isServiceManager,

    setIsSuperAdmin,
    getMyData,
  };
  return <UserContext.Provider value={values || {}}>{props.children}</UserContext.Provider>;
};

export default UserProvider;
